import {
  getRawAddEventListener,
  getRawRemoveEventListener,
} from '../../../shares/lib/rawEventListener';
import eventType from '../../../shares/enums/eventType';
import eventEmitters from '../../../shares/lib/eventEmitters';
import { getSDKConfig } from '../../../shares/lib/getSDKConfig';
import { getOTP } from './prepareOtp';

let isSubscribed = false;

export async function subscribeToMessages() {
  if (!isSubscribed) {
    const rawAddEventListener = getRawAddEventListener();
    rawAddEventListener('message', handleMessages);
    isSubscribed = true;
  }
}

export async function unsubscribeToMessages() {
  if (isSubscribed) {
    const rawRemoveEventListener = getRawRemoveEventListener();
    rawRemoveEventListener('message', handleMessages);
    isSubscribed = false;
  }
}

async function handleMessages(message: MessageEvent) {
  const { simulateSpecials } = getSDKConfig();
  const expectedOrigin = simulateSpecials?.iframeSourceUrl
    ? new URL(simulateSpecials.iframeSourceUrl).origin
    : null;
  const isValidOrigin = expectedOrigin && message.origin === expectedOrigin;

  if (!isValidOrigin) {
    return;
  }

  if (message.data.type === 'Simulate-Specials-OTP-Request') {
    try {
      const otp = await getOTP();
      message.source?.postMessage(
        { type: 'Simulate-Specials-OTP-Response', otp },
        { targetOrigin: message.origin },
      );
    } catch (error) {
      console.error('Failed to get OTP:', error);
      message.source?.postMessage(
        { type: 'otpError', error: 'Failed to get OTP' },
        { targetOrigin: message.origin },
      );
    }
  }

  if (
    message.data.type === 'Simulate-Specials-Refresh-Balance' &&
    simulateSpecials?.onRefreshBalance
  ) {
    simulateSpecials?.onRefreshBalance();
    eventEmitters(
      eventType.SIMULATE_SPECIALS_REFRESHBALANCE,
      'SimulateSpecials',
    );
  }
}
